import AppChrome from '../../components/AppChrome'
import DocumentContent from '../../components/document/DocumentContent'
import DocumentPageHeader from '../../components/document/DocumentPageHeader'
import HeroIllustration from '../../components/heroes/HeroIllustration'
import Background from '../../components/layout/Background'
import PageSegments from '../../components/pageSegments/PageSegments'

export { getServerSideProps } from '../../graphql/page'

function Page( { entry: page } ) {
  if ( page.typeHandle === 'document' ) {
    return (
      <div>
        <AppChrome>
          <Background $color="grey100">
            <DocumentPageHeader
              title={ page.title }
            />
            <DocumentContent contentBlocks={ page.documentContent } />
          </Background>
          <PageSegments pageSegments={ page.pageSegments } />
        </AppChrome>
      </div>
    )
  }

  const illi = page.heroIllustration[ 0 ]

  return (
    <div>
      <AppChrome
        navigationBar={ page.navigationMenu?.[ 0 ]?.navigationBar }
        footerPageSegments={ page.footer?.[ 0 ]?.pageSegments }
      >
        { illi && (
          <HeroIllustration 
            title={ page.mainTitle }
            subtitle={ page.subtitle }
            image={ illi.image[ 0 ] }
            objectPosition={ illi.objectPosition }
            imagePosition={ illi.horizontalAlignment }
            bgColor={ illi.backgroundColor }
            containerCSS={ illi.containerCss }
            buttonLabel={ page.buttonLabel }
            buttonLink={ page.buttonLink }
            partnerLabel={ page.partnerLabel }
            partnerLogos={ page.logos }
            testimonial={ page.testimonial[ 0 ] }
          />
        ) }
        { !illi && (
          <DocumentPageHeader
            title={ page.mainTitle }
            subtitle={ page.subtitle }
            centered
          />
        ) }
        <PageSegments pageSegments={ page.pageSegments } />
      </AppChrome>
    </div>
  )
}

export default Page
